import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";

import { formatDuration } from "../../../utils/date";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const MdcAverageTimeYard = (props) => {
  const { data } = props;

  const vehicleTypes = [
    {
      id: "truck",
      name: I18n.get("site_truck2"),
      icon: images.truckIconDarkGrey,
    },
    {
      id: "trailer",
      name: I18n.get("site_trailer"),
      icon: images.trailerIconDarkGrey,
    },
  ];

  if (!get(data, ["card8", "truck"])) {
    return null;
  }

  return (
    <DashboardCard
      title={I18n.get("dashboard_averageTimeInYard")}
      size={sizes.small}
      style={{
        margin: "12px",
        minWidth: "275px",
        flexGrow: 1,
      }}
    >
      <Grid
        container
        justify="space-evenly"
        alignItems="center"
        style={{ height: "100%" }}
      >
        {map(vehicleTypes, (type) => (
          <Grid item key={type.id} style={{ width: "150px" }}>
            <Grid container direction="column">
              <Grid item className="text-center text-87 bold-500">
                {get(type, ["name"])}
              </Grid>
              <Grid
                item
                className="flexCenter"
                style={{ justifyContent: "center", height: "40px" }}
              >
                <img
                  src={images.clockIconGrey}
                  alt="clock_icon"
                  style={{ maxHeight: "40px", marginRight: "5px" }}
                />
                <img
                  src={get(type, ["icon"])}
                  alt={type.id}
                  style={{
                    maxHeight: "30px",
                    minHeight: "25px",
                    marginLeft: "5px",
                  }}
                />
              </Grid>
              <Grid
                item
                style={{
                  fontWeight: 500,
                  fontSize: "2em",
                  lineHeight: "30px",
                  color: colors.primary,
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                {formatDuration(get(data, ["card8", type.id]))}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </DashboardCard>
  );
};

export default MdcAverageTimeYard;
